import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Commission } from 'src/model/commission.model';
import { Loan } from 'src/model/loan.model';
import { LoanGroup } from 'src/model/loanGroup.model';
import { LoanGroupService } from 'src/services/loan-group.service';
import { LoanService } from 'src/services/loan.service';
import { AddCommissionComponent } from '../add-commission/add-commission.component';

@Component({
    selector: 'app-assign-commission',
    templateUrl: './assign-commission.component.html',
    styleUrls: ['./assign-commission.component.scss'],
    standalone: false
})
export class AssignCommissionComponent implements OnInit {
  private router = inject(Router);
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  private cdr = inject(ChangeDetectorRef);
  private sharedService = inject(SharedService);
  private loanService = inject(LoanService);
  private loanGroupService = inject(LoanGroupService);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[];
  dataSource = new MatTableDataSource;

  loggedInRole: number;
  loggedInUsername: string;

  @Input() commissionList: Commission[];

  @Input() isModal = false;
  lastDate: Date;
  searchText: string;

  ngOnInit(): void {
    this.loggedInRole = Number(sessionStorage.getItem('roleId'));
    this.loggedInUsername = sessionStorage.getItem('username');

    // this.displayedColumns = ['CustomerName', 'Principal', 'Amount', 'Assignee', 'Action'];
    this.displayedColumns = ['CustomerName', 'Principal', 'CompanyCode', 'Action'];
    if (this.commissionList != undefined) {
      this.dataSource = new MatTableDataSource<Commission>(this.commissionList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  openAddCommissionModal(loan: Loan, lg: LoanGroup, index: number) {
    const modalRef = this.sharedService.openModal(AddCommissionComponent, "regularModal");
    modalRef.componentInstance.loan = loan;
    modalRef.componentInstance.loanGroup = lg;

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      this.commissionList.splice(index, 1);

      this.dataSource = new MatTableDataSource<Commission>(this.commissionList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.cdr.detectChanges();
    });
  }

  async addCommission(commission: Commission, index: number) {
    const loan = await this.loanService.getLoanById(commission.LoanId, true);
    const lg = await this.loanGroupService.getSingleLoanGroup(loan.LoanGroupId);
    this.openAddCommissionModal(loan, lg, index)
  }

  confirmBeforeAssignAll() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "You are going to clear all the commissions, are you sure about that?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.assignAllCommissions();
    });
  }

  assignAllCommissions() {
    const editIds: number[] = [];
    for (let i = 0; i < this.commissionList.length; i++) {
      editIds.push(Number(this.commissionList[i].LoanId))
    }
    this.batchAssignAmountAndAssignee(this.loggedInUsername, editIds, 0)
  }

  batchAssignAmountAndAssignee(assignee: string, loanIds: number[], amount: number) {
    const data = {
      "amount": amount,
      "loanIds": loanIds,
      "assignee": assignee,
      "dateCreated": new Date()
    }

    const xhr = this.restapi.postRequest(this.constructApi.getAssignCommission(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        // var jsonArray = JSON.parse((xhr.responseText));

        this.sharedService.openAlert("Successfully batch assign commission!", ALERT_TYPE.SUCCESS);
        window.location.reload();
      }
    };
  }

  setFilter(str: string) {
    this.searchText = str;
    this.applyFilter(str)
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  assignCommission(commission: Commission) {
    // alert(commission.Rate + "|" + commission.Assignee)
    if (commission.Assignee == undefined || commission.Amount == undefined)
      this.sharedService.openAlert("Please key in commission amount and assignee!", ALERT_TYPE.DANGER);
    else
      this.assignRateAndAssignee(commission, true);
  }

  assignRateAndAssignee(commission: Commission, showAlert: boolean) {
    const data = {
      "amount": Number(commission.Amount),
      "loanId": commission.LoanId,
      "assignee": commission.Assignee,
      "dateCreated": new Date()
    }

    const xhr = this.restapi.postRequest(this.constructApi.getAssignCommission(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        // var jsonArray = JSON.parse((xhr.responseText));

        if (showAlert == true)
          this.sharedService.openAlert("Successfully assign commission!", ALERT_TYPE.SUCCESS);
        commission.Assigned = true;
      }
    };
  }

  goToCustomer(selectedID: number) {
    // console.log("selcted:" + selectedID);
    // this.router.navigateByUrl('/manageCustomer', { state: { id: selectedID } });
    this.router.navigate(['/manageCustomer', selectedID]);
  }

  reset() {
    this.activeModal.close();
  }
}
